import { useEffect, useState } from 'react';

import {
	useSelectedBrands,
	useSelectedDateRange,
	useSelectedInluencers,
	useSelectedPreferences,
	useTrendResearchPreference
} from '@store/reducers/trend-research/TrendResearchReducer';

const useTrendResearchFilterParams = (removedParamList = ['instagramUserNameList']) => {
	const selectedBrands = useSelectedBrands();
	const selectedDateRange = useSelectedDateRange();
	const preferences = useTrendResearchPreference();
	const selectedInfluencers = useSelectedInluencers();
	const selectedPreferences = useSelectedPreferences();
	const [queryParams, setQueryParams] = useState(null);

	let productGroupResponseList =
		selectedPreferences.productGroupResponseList.length > 0
			? selectedPreferences.productGroupResponseList
			: preferences?.productGroupResponseList?.map((item) => item.id) || [];

	let fabricTypeList =
		selectedPreferences.fabricTypeList.length > 0
			? selectedPreferences.fabricTypeList
			: preferences?.fabricTypeList?.map((item) => item.constant) || [];

	let categoryResponseList =
		selectedPreferences.categoryResponseList.length > 0
			? selectedPreferences.categoryResponseList
			: preferences?.categoryResponseList?.map((item) => item.id) || [];

	useEffect(() => {
		let tmpObj = '';

		if (selectedBrands.length > 0 && !removedParamList.includes('brandCodeList')) {
			tmpObj += `brandCodeList=${selectedBrands.join(',')}&`;
		}
		if (productGroupResponseList.length > 0 && !removedParamList.includes('marketIdList')) {
			tmpObj += `marketIdList=${productGroupResponseList.join(',')}&`;
		}
		if (fabricTypeList.length > 0 && !removedParamList.includes('fabricTypeList')) {
			tmpObj += `fabricTypeList=${fabricTypeList.join(',')}&`;
		}
		if (categoryResponseList.length > 0 && !removedParamList.includes('categoryIdList')) {
			tmpObj += `categoryIdList=${categoryResponseList.join(',')}&`;
		}
		if (selectedDateRange?.key && !removedParamList.includes('dateRange')) {
			let selectedDate = selectedDateRange.key;
			let splitDate = selectedDate.split(',');
			tmpObj += `startDate=${splitDate[0]}&`;
			tmpObj += `endDate=${splitDate[1]}&`;
		}

		if (selectedInfluencers.length > 0 && !removedParamList.includes('instagramUserNameList')) {
			tmpObj += `instagramUserNameList=${selectedInfluencers.join(',')}&`;
		}

		if (tmpObj !== '') {
			if (tmpObj.endsWith('&')) {
				tmpObj = tmpObj.slice(0, -1);
			}
			tmpObj = `?${tmpObj}`;
		}
		setQueryParams(tmpObj);
	}, [selectedBrands, selectedPreferences, selectedDateRange, selectedInfluencers]);

	return { queryParams };
};

export default useTrendResearchFilterParams;
